import Plausible from 'plausible-tracker'

class PlausibleTracker {
    constructor(domain, hashMode = true, trackLocalHost = false, active = true) {
        this.domain = domain;
        this.hashMode = hashMode;
        this.trackLocalHost = trackLocalHost;

        this.active = active;
    }

    get _options() {
        return {
            domain: this.domain,
            hashMode: this.hashMode,
            trackLocalhost: this.trackLocalHost
        }
    }

    /**
     * Track page view
     */
    trackPageview() {
        if (this.active === true) {
            const {trackPageview} = Plausible(this._options)
            trackPageview();
        }
    }

    /**
     * Track event in Plausible
     * @param name
     * @param props
     */
    _trackEvent(name, props = null) {
        if (this.active === true) {
            const {trackEvent} = Plausible(this._options)
            trackEvent(name, props !== null ? {props: props} : null);
        }
    }

    /**
     * Track sign-up event
     * @param email_ref E-mail to track
     */
    trackEventSignup(email_ref) {
        this._trackEvent('signup', {email_ref: email_ref});
    }

    /**
     * Track sign-up event
     * @param email_ref E-mail to track
     */
    trackEventFeedback(email_ref) {
        this._trackEvent('feedback', {email_ref: email_ref});
    }

}

export default new PlausibleTracker(
    process.env.VUE_APP_PLAUSIBLE_DOMAIN,
    process.env.VUE_APP_PLAUSIBLE_HASH_MODE === 'true',
    process.env.VUE_APP_PLAUSIBLE_TRACK_LOCALHOST === 'true',
    process.env.VUE_APP_PLAUSIBLE_ACTIVE === 'true'
);